import { DocumentType, InitialDataAggregation } from 'model';
import { AsyncThunk, EntityId } from '@reduxjs/toolkit';
import {
  createAdapterSelectors,
  createEntitySlice,
  CustomThunk
} from '../../../redux/enitySlice';
import { documentTypesThunk } from './document-type.thunk';
import { EntityAPI } from '../../../redux/entity-api.hook';
import { fetchInitialDataThunk } from '../../../redux/initial-data.thunk';

const { list, delete: deleteThunk, ...thunks } = documentTypesThunk;

const documentTypesSlice = createEntitySlice<DocumentType>('document-types', [
  CustomThunk.override<DocumentType>(list, {
    pending: (_, state) => {
      state.state = 'pending';
      state.listFetched = undefined;
      state.error = null;
      return state;
    },
    rejected: (_, state, action) => {
      state.state = 'idle';
      state.listFetched = false;
      state.error = (action as any).error;
      return state;
    },
    fulfilled: (adapter, state, { payload }) => {
      state.state = 'idle';
      state.listFetched = true;
      return adapter.upsertMany(state, payload as DocumentType[]);
    }
  }),
  CustomThunk.override<any>(fetchInitialDataThunk, {
    pending: (_, state) => {
      return state;
    },
    rejected: (_, state) => {
      return state;
    },
    fulfilled: (adapter, state, { payload }) => {
      const dataPayload = payload as InitialDataAggregation;
      if (dataPayload.supplierDocumentTypes) {
        state.state = state.state === 'fresh' ? 'idle' : state.state;
        state.listFetched = true;
        return adapter.upsertMany(state, dataPayload.supplierDocumentTypes);
      }
      return state;
    }
  }),
  CustomThunk.override<DocumentType>(
    deleteThunk as AsyncThunk<EntityId, { id: EntityId }, any>,
    {
      fulfilled: (adapter, state, { payload }) => {
        state.state = 'idle';
        return adapter.removeOne(state, payload as string);
      }
    }
  ),
  ...Object.values(thunks)
]);

export const documentTypesSelectors = createAdapterSelectors(
  'document-types',
  documentTypesSlice.adapter
);

export const documentTypesAPI: EntityAPI<DocumentType> = {
  selectors: documentTypesSelectors,
  thunks: documentTypesThunk
};

export default documentTypesSlice;
